import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

/** Full-height app frame on the mint-white ground. */
export function AppShell({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("pz-shell", className)} {...rest} />;
}

export interface TopbarProps extends HTMLAttributes<HTMLElement> {
  /** Leading slot — the Wordmark lives here. */
  start?: ReactNode;
  /** Trailing slot — actions, theme switcher, account chip. */
  end?: ReactNode;
}

/** The quiet chrome bar (z.chrome) around the map hero. */
export function Topbar({ start, end, className, ...rest }: TopbarProps) {
  return (
    <header className={cx("pz-topbar", className)} {...rest}>
      {start}
      <div className="pz-topbar__actions">{end}</div>
    </header>
  );
}

/** Main content region of the shell. */
export function ShellMain({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return <main className={cx("pz-shell__main", className)} {...rest} />;
}
